import { render, staticRenderFns } from "./WxNews.vue?vue&type=template&id=767fe273&scoped=true"
import script from "./WxNews.vue?vue&type=script&lang=js"
export * from "./WxNews.vue?vue&type=script&lang=js"
import style0 from "./WxNews.vue?vue&type=style&index=0&id=767fe273&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767fe273",
  null
  
)

export default component.exports